/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Invalid_OtpInputs */

const en_two_fa_invalid_otp = /** @type {(inputs: Two_Fa_Invalid_OtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid authenticator code. Please try again.`)
};

const nl_two_fa_invalid_otp = /** @type {(inputs: Two_Fa_Invalid_OtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige authenticatorcode. Probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Invalid authenticator code. Please try again." |
*
* @param {Two_Fa_Invalid_OtpInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_invalid_otp = /** @type {((inputs?: Two_Fa_Invalid_OtpInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Invalid_OtpInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_invalid_otp(inputs)
	return en_two_fa_invalid_otp(inputs)
});